export default "__VITE_ASSET__CzrWQaw___"